import { useBearAuthSession } from '@bear-auth/react';
import { Navigate, useParams } from 'react-router-dom-v5-compat';

import config from '@/config';
import { useGetSharedSecret } from '@/modules/api/codegen';
import { Loadable } from '@/modules/ui';
import { ErrorCode } from '@/services/utilities/isApiError';

import type { Secret, Share } from '../../types';
import { AlertContainer, SecretDetailAlerts, type SecretDetailAlertsProps } from './SecretDetailAlerts';
import { SharedSecret } from './SharedSecret';

// TODO: fix e2e test
// if (!id) return <Empty text={<FormattedMessage id='secret.detail.empty' />} data-testid='secrets-detail-empty' />;
export const SharedSecretDetailPage = () => {
    const { id: shareId } = useParams<{ id: Share['id'] }>();
    const sharedSecretResult = useGetSharedSecret(
        { shareId: shareId! },
        {
            query: {
                retry(failureCount, error) {
                    if (error.isAntonioError && [403, 404].includes(error.response.status)) {
                        return false;
                    }

                    if (error.isAntonioError && error.data.errorCode === ErrorCode.SHARING_LINK_EXPIRED) {
                        return false;
                    }
                    return failureCount < 3;
                },
            },
        },
    );
    const { status } = useBearAuthSession();

    if (!shareId) {
        return <Navigate to={config.routes.home} />;
    }

    if (sharedSecretResult.isLoading) {
        return <Loadable showLoader={true} minHeight={'100vh'} />;
    }

    if (sharedSecretResult.error) {
        return (
            <AlertContainer>
                <SecretDetailAlerts error={sharedSecretResult.error} authStatus={status as SecretDetailAlertsProps['authStatus']} />
            </AlertContainer>
        );
    }

    return (
        <SharedSecret secret={sharedSecretResult.data?.data.secret as Secret} shareDetails={sharedSecretResult.data?.data.shareDetails} />
    );
};
